import { useGetClock, useGetMargin } from "~/v2/api/hooks";
import { CLOCK_POLLING_INTERVAL } from "~/v2/constants";
import type { SelectedContract } from "~/v2/pages/dashboard/tradeV2";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { useMultiLegOrderTicketController } from "./MultiLegOrderTicket.controller";
import { MultiLegOrderTicketPresentation } from "./MultiLegOrderTicket.pres";

export interface MultiLegOrderTicketConnectorProps {
  underlyingSymbol: string;
  legs: readonly SelectedContract[];
  onRemoveLeg: (symbol: string) => void;
  onUpdateLegType: (symbol: string, type: string) => void;
  fill?: boolean;
}

export const MultiLegOrderTicketConnector = ({
  underlyingSymbol,
  legs,
  onRemoveLeg,
  onUpdateLegType,
  fill,
}: MultiLegOrderTicketConnectorProps) => {
  const { product, currentAccount } = useAccountContext();

  const { clock } = useGetClock({
    options: { refetchInterval: CLOCK_POLLING_INTERVAL },
  });

  const { margin } = useGetMargin({
    accountID: currentAccount?.id,
    paper: product !== "live",
    options: {
      enabled: !!currentAccount?.id,
    },
  });

  const controllerProps = useMultiLegOrderTicketController({
    account: currentAccount,
    margin: margin ?? undefined,
    product,
    clock,
    underlyingSymbol,
    propLegs: legs,
    onRemoveLeg,
    onUpdateLegType,
  });

  return <MultiLegOrderTicketPresentation {...controllerProps} fill={fill} />;
};
